const getAnalyticsUrl = () => {
    const hst = document.location.hostname;
    const ssaSite = hst.includes("ssa.");
    const riaSite = hst.includes("ria.");
    const annMySite = hst.includes("annuities.myaccount") || hst.includes("myaccount-");
    const annSite = hst.includes("annuities.") && !annMySite;

    const annFinPro = process.env.REACT_APP_ADOBE_ANALYTICS_ANN_BRK;
    const annMyAcct = process.env.REACT_APP_ADOBE_ANALYTICS_ANN_MYA;
    const ssaUsers = process.env.REACT_APP_ADOBE_ANALYTICS_SSA;
    const riaUsers = process.env.REACT_APP_ADOBE_ANALYTICS_RIA;
    
    if (ssaSite) return ssaUsers;
    if (riaSite) return riaUsers;  
    if (annSite) return annFinPro;
    if (annMySite) return annMyAcct;
};

export const analytics = () => {
    const script = document.createElement("script");
    script.src = getAnalyticsUrl();
    script.async = true;
    document.body.appendChild(script);
};
